import { P, FF } from "../../styles/tokens";
import { fmt } from "../../utils/format";

export default function StatCard({ icon, label, value, token, sub, compact, note }) {
  const t = token || P.ingresos;
  const isNeg = typeof value === "number" && value < 0;
  const dt = isNeg ? P.danger : t;

  if (compact) {
    return (
      <div
        style={{
          background: P.surface,
          borderRadius: 16,
          padding: "14px 16px",
          border: `1.5px solid ${P.border}`,
          display: "flex",
          alignItems: "center",
          gap: 12,
        }}
      >
        <div
          style={{
            width: 40, height: 40, borderRadius: 13, background: dt.pastel,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 18, flexShrink: 0,
          }}
        >
          {icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: P.textXs, fontFamily: FF, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 3 }}>
            {label}
          </div>
          <div style={{ fontSize: 22, fontWeight: 900, color: dt.text, fontFamily: FF, letterSpacing: "-0.8px", lineHeight: 1 }}>
            {fmt(value)}
          </div>
          {sub && <div style={{ fontSize: 10, color: P.textXs, fontFamily: FF, marginTop: 3 }}>{sub}</div>}
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: P.surface, borderRadius: 16, padding: "18px 20px", border: `1.5px solid ${P.border}` }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
        <div
          style={{
            width: 38, height: 38, borderRadius: 12, background: dt.pastel,
            display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18,
          }}
        >
          {icon}
        </div>
      </div>
      <div style={{ fontSize: 10, fontWeight: 600, color: P.textXs, fontFamily: FF, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>
        {label}
      </div>
      <div style={{ fontSize: 32, fontWeight: 900, color: dt.text, fontFamily: FF, letterSpacing: "-1.2px", lineHeight: 1 }}>
        {fmt(value)}
      </div>
      {sub && <div style={{ fontSize: 11, color: P.textSm, fontFamily: FF, marginTop: 8 }}>{sub}</div>}
      {note && <div style={{ fontSize: 11, fontWeight: 600, color: dt.mid, fontFamily: FF, marginTop: 6 }}>{note}</div>}
    </div>
  );
}
